// extracted by mini-css-extract-plugin
export default {"title":"Login_title__JYH7u"};